var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditional2ActivityCoral({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFE7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 14.3081V12.4841H5V11.1161H6.8V9.29213H8.216V11.1161H10.016V12.4841H8.216V14.3081H6.8Z",
    fill: "#FF865D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7334 16.0001V14.9921C11.7334 14.4081 11.8294 13.9241 12.0214 13.5401C12.2134 13.1481 12.4894 12.8281 12.8494 12.5801C13.2174 12.3241 13.6654 12.1161 14.1934 11.9561L14.9974 11.7041C15.2934 11.6081 15.5414 11.4921 15.7414 11.3561C15.9414 11.2121 16.0934 11.0401 16.1974 10.8401C16.3094 10.6401 16.3654 10.4121 16.3654 10.1561V10.1081C16.3654 9.70813 16.2294 9.39213 15.9574 9.16013C15.6854 8.92013 15.3134 8.80013 14.8414 8.80013C14.3774 8.80013 14.0014 8.92813 13.7134 9.18413C13.4334 9.43213 13.2934 9.79213 13.2934 10.2641V10.4801H11.7574V10.2881C11.7574 9.68013 11.8934 9.16413 12.1654 8.74013C12.4374 8.31613 12.8054 7.99213 13.2694 7.76813C13.7414 7.54413 14.2654 7.43213 14.8414 7.43213C15.4174 7.43213 15.9374 7.54413 16.4014 7.76813C16.8654 7.98413 17.2294 8.29213 17.4934 8.69213C17.7654 9.08413 17.9014 9.54813 17.9014 10.0841V10.2041C17.9014 10.7401 17.7894 11.1961 17.5654 11.5721C17.3494 11.9401 17.0534 12.2441 16.6774 12.4841C16.3014 12.7161 15.8734 12.9081 15.3934 13.0601L14.6254 13.3001C14.2814 13.4041 14.0134 13.5201 13.8214 13.6481C13.6294 13.7681 13.4934 13.9041 13.4134 14.0561C13.3414 14.2001 13.3054 14.3761 13.3054 14.5841V14.6321H17.8294V16.0001H11.7334Z",
    fill: "#FF865D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditional2ActivityCoral);
export default __webpack_public_path__ + "static/media/additional-2-activity-coral.c2d594e2f09ea80ee6375131c62963dc.svg";
export { ForwardRef as ReactComponent };